function getCookie(cname) {
    return localStorage.getItem(cname);
}

function setCookie(cname, cvalue) {
    if (typeof cvalue == 'object') {
        cvalue = JSON.stringify(cvalue);
    }

    console.log({ cvalue });

    localStorage.setItem(cname, cvalue);
}

function eraseCookie(name) {
    localStorage.removeItem(name);
}

function eraseBundleCookies() {
    eraseCookie('OB.bundleProduct');
    eraseCookie('OB.openBundle');
    eraseCookie('OB.bundleNeeds');
    eraseCookie('OB.bundleProductTitle');
    eraseCookie('OB.fullPriceID');
}

function saveOrthoticToCookie(product_data, product_title, full_price_id) {
    setCookie('OB.bundleProduct', product_data);
    setCookie('OB.openBundle', 'true');
    setCookie('OB.bundleNeeds', 'shoes');
    setCookie('OB.bundleProductTitle', product_title);
    setCookie('OB.fullPriceID', full_price_id);
}

function saveShoeToCookie(product_data, product_title) {
    setCookie('OB.bundleProduct', product_data);
    setCookie('OB.openBundle', 'true');
    setCookie('OB.bundleNeeds', 'shoes');
    setCookie('OB.bundleProductTitle', product_title);
}
